import {apiClient} from "../connection/BlinkApiClient";
import {PaymentStatusDependentStore} from "./misc/StoreUtils";
import {PaymentMethod} from "./PaymentMethodStore";
import {BaseEnum, makeEnum} from "../../stem-core/state/BaseEnum";
import {field} from "../../stem-core/state/StoreField";
import {Currency} from "../../stem-core/localization/CurrencyStore";
import {Money} from "../../stem-core/localization/Money";
import {BaseStore, globalStore} from "../../stem-core/state/Store";
import {StemDate} from "../../stem-core/time/Date";
import {Merchant} from "./MerchantStore";
import {UserProfile} from "./UserProfileStore";
import {Wallet} from "./WalletStore";

@makeEnum
export class TopUpStatus extends BaseEnum {
    static NOT_PROCESSED;
    static FAILED;
    static SUCCEEDED;
    static REVERTED;
}

@globalStore
export class TopUpPayment extends BaseStore("TopUpPayment", {}, PaymentStatusDependentStore) {
    static Source = {
        PAYMENT_METHOD: "payment_method",
        CREDIT: "blink_credit",
    };

    @field("Merchant") merchant: Merchant;
    @field("UserProfile") user: UserProfile;
    @field("PaymentMethod") paymentMethod: PaymentMethod;
    @field(Date) createdAt: StemDate;
    @field(TopUpStatus) status: TopUpStatus;
    @field(Boolean) isAutomatic: boolean;

    declare currencyId: number;
    declare amount: number;
    declare paymentMethodId: number;

    // TODO @types @cleanup this inherits from MoneyObject, but for the other shit in PaymentStatusDependentStore
    getCurrency(): Currency | undefined {
        return Currency.get(this.currencyId);
    }

    getAmount(): Money {
        const currency = this.getCurrency();
        return new Money(this.amount, currency);
    }
    // TODO @branch other fields are still required

    // TODO @cleanup deprecate
    getPaymentMethod(): PaymentMethod | undefined {
        return PaymentMethod.get(this.paymentMethodId);
    }
}

export async function apiUserTopUp(amount: number, paymentMethod: PaymentMethod, userWallet: Wallet): Promise<TopUpPayment> {
    const response = await apiClient.post("/top_up_payments/top_up", {
        amount,
        paymentMethodId: paymentMethod.id,
        walletId: userWallet.id,
    });
    return TopUpPayment.loadObject(response);
}

export async function apiAdminMarkChargeFailed(request: any): Promise<any> {
    return apiClient.post("/admin/top_up_payments/edit_status_failed", request);
}
